import { Chip, Text, NumberEasing } from '@/components'
import { isDecimal } from '@/utils/number'

export interface Props {
  monthSavingsAmount: number
  loading?: boolean
}

export default function ThermostatSavingsChip({
  monthSavingsAmount,
  loading = false,
}: Props) {
  const chipDecimals = isDecimal(monthSavingsAmount) ? 2 : 0

  if (loading || monthSavingsAmount <= 0) {
    return null
  }

  return (
    <Chip className="bg-themed-green-100 py-1 px-3 rounded-lg w-fit">
      <Text className="text-themed-green-700">
        +$
        <NumberEasing
          value={monthSavingsAmount}
          decimals={chipDecimals}
          speed={400}
          ease="quintOut"
        />
      </Text>
    </Chip>
  )
}
